import { render, staticRenderFns } from "./DashboardWidgetsForm.vue?vue&type=template&id=9bf93242"
import script from "./DashboardWidgetsForm.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports